import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';

export const OcurrencesByDay = () => {
    const { chartData } = useServicesChartsDataContext();

    return (
        <SimpleBars
            title={'Ocorrências por período (Dias da semana)'}
            horizontal={false}
            subtitles={chartData?.ocurrencesByDay?.map((item) => item.description)}
            values={chartData?.ocurrencesByDay?.map((item) => item.total || 0)}
        />
    );
};